import moment from 'moment';

import appboyService from 'services/appboy';

import SEGMENT_EVENTS from 'constants/segmentEvents';

trackingService.$inject = [
  '$rootScope',
  'segment',
  'tl.user.service',
  'tl.track.service',
  'tl.user.service',
  'tl.ee',
  'tl.config'
];

export default function trackingService($rootScope, segmentService, userService, tlTrackingService, UserService, tlEE, tlConfig) {
  tlEE.on(UserService.EVENTS().USER_UPDATED, function(event, user) {
    identify(user);
  });

  $rootScope.$on('$stateChangeSuccess', function() {
    pageview();

    if ($rootScope.currentUser) {
      identify($rootScope.currentUser);
    }
  });

  $rootScope.$on('login', function() {
    trackEvent(SEGMENT_EVENTS.LoggedIn);
  });

  $rootScope.$on('logout', function() {
    trackEvent(SEGMENT_EVENTS.LoggedOut);
  });

  function pageview() {
    return segmentService.page();
  }

  function identify(user) {
    if (!user) return null;

    const createdAt = moment(user.created).toISOString();

    const traits = {
      firstName: user.firstName,
      lastName: user.lastName,
      name: user.name,
      email: user.email,
      gender: user.gender,
      phone: user.phone,
      createdAt: createdAt
    };

    appboyService.resumeWebTracking();

    appboyService.init();

    appboyService.identify(user);

    window.snaptr('init', '02831f2c-e454-4816-95c6-c81efcec10b2', {
      user_email: user.email
    });

    return segmentService.identify(user.id, traits);
  }

  function trackEvent(eventName, eventData = {}) {
    if (!eventName) {
      console.log('Tracking Error. No segment event name provided');

      return;
    }

    if (!Object.values(SEGMENT_EVENTS).includes(eventName)) {
      console.log(`Unable to find valid segment event for ${eventName}. Please send a correct tracking event`);

      return;
    }

    console.log('TRACK EVENT', eventName);

    eventData.src = tlConfig.SUB_CLIENT;

    segmentService.track(eventName, eventData);

    tlTrackingService.send(eventName, eventData);

    appboyService.track(eventName, eventData);

    window.snaptr('track', 'PAGE_VIEW');
  }

  return {
    trackEvent,
    identify
  };
}



// WEBPACK FOOTER //
// ./src/services/trackingService.js